import { isEmpty, map } from 'underscore';

const getAudienceIdArray = (audiences) => {
  if (isEmpty(audiences)) {
    return 'delete_value';
  }

  return map(audiences, audience => audience.Id).join(';');
};

const getProfileIdArray = (profiles) => {
  if (isEmpty(profiles)) {
    return 'delete_value';
  }

  return profiles.join(';');
};

export const AudienceGroup = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Audience Group',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    Name: {
      'bulk-upload-header': 'Audience Group Name',
    },
    Audiences: {
      'bulk-upload-header': 'Audiences',
      'bulk-upload-mapper': getAudienceIdArray,
    },
    NegativeAudiences: {
      'bulk-upload-header': 'Negative Audiences',
      'bulk-upload-mapper': getAudienceIdArray,
    },
    companyNameTargets: {
      'bulk-upload-header': 'Company Name',
      'bulk-upload-mapper': getProfileIdArray,
    },
    industry: {
      'bulk-upload-header': 'Industry',
      'bulk-upload-mapper': getProfileIdArray,
    },
    jobTargets: {
      'bulk-upload-header': 'Job Function',
      'bulk-upload-mapper': getProfileIdArray,
    },
    AgeRanges: {
      'bulk-upload-header': 'Age Ranges',
      'bulk-upload-mapper': function (value) {
        return value.join(';');
      },
    },
    GenderTypes: {
      'bulk-upload-header': 'Gender Types',
      'bulk-upload-mapper': function (value) {
        return value.join(';');
      },
    },
  },
};
